import { render, staticRenderFns } from "./LotteryWheel.vue?vue&type=template&id=5ace1073&scoped=true"
import script from "./LotteryWheel.vue?vue&type=script&lang=js"
export * from "./LotteryWheel.vue?vue&type=script&lang=js"
import style0 from "./LotteryWheel.vue?vue&type=style&index=0&id=5ace1073&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ace1073",
  null
  
)

export default component.exports